import { useEffect, useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useEntidad, useManagedContext } from "../../components/hooks"
import { ServerRequest } from "../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { SectionHeading, TableCustom, WrapperAdvancedSearch } from "../../components/common"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { getDateToString, getFormatNumber, truncateTime } from "../../utils/convert"
import RegistrosIngresosPublicosGridModal from "../../components/controls/RegistrosIngresosPublicosGridModal"

const initItem = {
    id: 0
}

const RendicionIngresosPublicosHistorialView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()
    const location = useLocation()
    const navigate = useNavigate()

    const volverAlVep = location.state?.volverAlVep

    const searchRef = useRef()

    const [lotes, setLotes] = useState([])
    const [editItem, setEditItem] = useState(initItem)
    const [showDetalle, setShowDetalle] = useState(false)

    const [, getRowEntidad] = useEntidad({
        entidades: ['Recaudadora'],
        onLoaded: (_, isSuccess, error) => {
            if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
            key: 'Recaudadora',
            timeout: 0
        }
    })

    useEffect(() => SearchLotes(), [])

    const filterData = data => {
        const { numeroLote, fechaProcesoDesde,  fechaProcesoHasta} = searchRef.current.filters

        let filtered = [...data]

        if (numeroLote !== '') filtered = filtered.filter(item => item.numeroLote.indexOf(numeroLote) >= 0)
        if (fechaProcesoDesde) filtered = filtered.filter(item => truncateTime(item.fechaProceso).getTime() >= truncateTime(fechaProcesoDesde).getTime())
        if (fechaProcesoHasta) filtered = filtered.filter(item => truncateTime(item.fechaProceso).getTime() <= truncateTime(fechaProcesoHasta).getTime())

        return filtered
    }

    const SearchLotes = () => {
        setIsLoading(true)

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PAGO_RENDICION_LOTE,
            null,
            null,
            res => res.json().then(data => {
                data.forEach(row => {
                    if (row.fechaLote) row.fechaLote = new Date(row.fechaLote);
                    if (row.fechaProceso) row.fechaProceso = new Date(row.fechaProceso);
                    if (row.fechaControl) row.fechaControl = new Date(row.fechaControl);
                    if (row.fechaConciliacion) row.fechaConciliacion = new Date(row.fechaConciliacion);
                    if (row.fechaAcreditacion) row.fechaAcreditacion = new Date(row.fechaAcreditacion);
                })
                data.sort((a,b) => b.id - a.id)
                setLotes(filterData(data))
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onView: (item) => {
            setEditItem(item)
            setShowDetalle(true)
        }
    }

    const onModalCancel = () => {
        setShowDetalle(false)
        setEditItem(initItem)
    }


    return <>
        <SectionHeading titles={[{ title: 'Rendiciones' }, { title: 'Historial de rendición a ingresos públicos' }]} />

        <section className='section-accordion'>
            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'N° lote', field: 'numeroLote', type: 'string', size: 4, searchOnEnter: true, presetValue: location.state?.numeroLote },
                    { title: 'Fecha proceso desde', field: 'fechaProcesoDesde', type: 'date', size: 4 },
                    { title: 'Fecha proceso hasta', field: 'fechaProcesoHasta', type: 'date', size: 4, minValueField: 'fechaProcesoDesde' },
                ]}
                onSearch={SearchLotes}
            />

            <TableCustom
                className={'TableCustomBase m-top-20'}
                data={lotes}
                avmr={avmr}
                columns={[
                    { Header: 'N° lote', accessor: 'numeroLote', width: '17%', },
                    { Header: 'Fecha lote', accessor: 'fechaLote', Cell: (data) => getDateToString(data.value), width: '11%'},
                    { Header: 'Fecha proceso', accessor: 'fechaProceso', Cell: (data) => getDateToString(data.value, true), width: '16%'},
                    { Header: 'Fecha confirmación', accessor: 'fechaConfirmacion', Cell: (data) => getDateToString(data.value, true), width: '16%' },
                    { Header: 'Casos', accessor: 'casos', Cell: (data) => getFormatNumber(data.value, 0), width: '9%', alignCell: 'right' },
                    { Header: 'Importe total', accessor: 'importeTotal', Cell: (data) => getFormatNumber(data.value, 2), width: '15%', alignCell: 'right' },
                    { Header: 'Recaudadora', accessor: 'idRecaudadoraPrincipal', Cell: ({ value }) => getRowEntidad('Recaudadora', value)?.nombre ?? '', width: '16%' }
                ]}
            />

            {showDetalle && (
                <RegistrosIngresosPublicosGridModal
                    idPagoRendicionLote={editItem.id}
                    onCancel={onModalCancel}
                />
            )}

        </section>

        {volverAlVep && (
            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    <button className="btn back-button float-start" onClick={() => navigate(volverAlVep.to, { state: volverAlVep.state })}>Volver al VEP</button>
                </div>
            </footer>
        )}
    </>
}

export default RendicionIngresosPublicosHistorialView
